export const ACCORDION_STYLES = {
  item: "",
  trigger: "flex flex-1 items-center justify-between py-4 text-sm font-medium transition-all hover:underline text-left [&[data-state=open]>svg]:rotate-180",
  content: "overflow-hidden text-sm data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down",
  contentInner: "pb-4 pt-0",
} as const; 